import React from 'react';

const ProgressBar = ({ status }) => {
  const getProgress = () => {
    switch (status) {
      case 'pending':
        return 25;
      case 'running':
        return 60;
      case 'completed':
        return 100;
      case 'failed':
        return 100;
      default:
        return 0;
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'pending':
        return 'Starting bot...';
      case 'running':
        return 'Generating outputs...';
      case 'completed':
        return 'Complete!';
      case 'failed':
        return 'Failed';
      default:
        return 'Initializing...';
    }
  };

  const getColor = () => {
    if (status === 'failed') return 'bg-red-600';
    if (status === 'completed') return 'bg-emerald-600';
    return 'bg-blue-600';
  };

  return (
    <div className="space-y-2" data-testid="progress-bar">
      <div className="flex justify-between items-center">
        <span className="text-sm font-medium text-slate-700">{getStatusText()}</span>
        <span className="text-sm font-medium text-slate-500">{getProgress()}%</span>
      </div>
      <div className="h-2 bg-slate-200 rounded-full overflow-hidden">
        <div
          className={`h-full ${getColor()} transition-all duration-500 ease-out`}
          style={{ width: `${getProgress()}%` }}
          data-testid="progress-bar-fill"
        />
      </div>
    </div>
  );
};

export default ProgressBar;
